import { useLocation } from "react-router-dom";

/**
 * Hook para breadcrumb "volver" contextual.
 *
 * En el caller (listado padre / tab), usar:
 *   <Link to="/facturas/:id" state={{ from: "/clientes/abc", fromLabel: "Manuel" }} />
 *
 * En el detail page, este hook lee el state y devuelve el back contextual.
 * Si no hay state (llegaste por URL directa o refresco), cae al default.
 */
export function useBackLink(
  defaultPath: string,
  defaultLabel: string,
): { path: string; label: string } {
  const location = useLocation();
  const state = location.state as { from?: string; fromLabel?: string } | null;
  if (state?.from && state?.fromLabel) {
    return { path: state.from, label: state.fromLabel };
  }
  return { path: defaultPath, label: defaultLabel };
}
